import { z } from 'zod';
const field = z.string().regex(/^(?:UF_CRM_[A-Z0-9_]+|SOURCE_DESCRIPTION)$/).or(z.literal(''));
export const bitrixDealConfigSchema = z.object({
    enabled: z.boolean().default(false),
    startAt: z.string().datetime({ offset: true }),
    categoryId: z.string().regex(/^\d+$/).default('46'),
    stageId: z.string().min(1).max(100).default('C46:UC_9HDWZN'),
    ownerId: z.string().regex(/^\d+$/).default('318'),
    labelCodes: z.array(z.string().min(1).max(50)).min(1).max(20).default(['lead']),
    utmField: z.string().regex(/^UF_CRM_[A-Z0-9_]+$/).default('UF_CRM_T_UTMSOURCE'),
    utmValue: z.string().min(1).max(100).default('FG_KC_HUMAN'),
    duplicateMode: z.enum(['review', 'comment', 'create']).default('review'),
    descriptionMode: z.enum(['telegram', 'template']).default('telegram'),
    titleTemplate: z.string().min(1).max(250).default('КЦ · {{name}} · {{phone}}'),
    commentTemplate: z.string().min(1).max(8000).default('Первичный разговор: диспетчер {{dispatcher}}.\n\n{{summary}}\n\n{{questionnaire}}\nЗаявка КЦ: {{assignmentId}}'),
    fields: z.object({ debt: field.default('UF_CRM_R_SUMMADOLGAN'), debtTypes: field.default('UF_CRM_R_TIPDOLGOV'), city: field.default('UF_CRM_R_GOROD'), region: field.default('UF_CRM_T_UTMREGION'), mortgage: field.default('UF_CRM_R_ESTLIIPOTEK'), auto: field.default('UF_CRM_R_ESTLIUVASAV'), source: field.default('SOURCE_DESCRIPTION') }).default({}),
}).strict();
//# sourceMappingURL=bitrix-deals.dto.js.map